import { render, staticRenderFns } from "./DiscussionList.vue?vue&type=template&id=21f158c0&scoped=true&"
import script from "./DiscussionList.vue?vue&type=script&lang=js&"
export * from "./DiscussionList.vue?vue&type=script&lang=js&"
import style0 from "./DiscussionList.vue?vue&type=style&index=0&id=21f158c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f158c0",
  null
  
)

export default component.exports